import {
  Component,
  EventEmitter,
  Input,
  Output,
  ChangeDetectionStrategy,
} from '@angular/core';
import moment from 'moment';
import { IAvailability, IBookingCreate } from 'src/app/models';
import { BookingsService, LiteralService } from 'src/app/services';
import { images } from 'src/images';

@Component({
  selector: 'app-booking-availability-detail',
  templateUrl: './booking-availability-detail.component.html',
  styleUrl: './booking-availability-detail.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class BookingAvailabilityDetailComponent {
  @Input() trip: IAvailability[];
  @Input() newBooking: IBookingCreate;
  @Input() pax: number;
  @Output() closeDetail: EventEmitter<void> = new EventEmitter<void>();

  public images = images;
  public moment = moment;

  constructor(
    public literalService: LiteralService,
    public bookingsService: BookingsService,
  ) {}

  get totalPrice(): number | null {
    const prices = this.trip
      .filter((leg) => leg.price != null)
      .map((leg) => leg.price!);
    return prices.length ? prices.reduce((sum, price) => sum + price, 0) : null;
  }

  isAlternativeOrigin(leg: IAvailability) {
    return leg === this.trip[0] && !!leg.alternative && this.bookingsService.isAlternativeOnInitial(leg, this.newBooking);
  }

  isAlternativeDestination(leg: IAvailability) {
    return leg === this.trip[this.trip.length - 1] && !!leg.alternative && this.bookingsService.isAlternativeOnFinal(leg, this.newBooking);
  }

  hasAlternativeInitialWalk(leg: IAvailability) {
    return (
      !leg.walkingPickup &&
      !!leg.alternative &&
      this.bookingsService.isAlternativeOnInitial(leg, this.newBooking)
    );
  }

  hasAlternativeFinalWalk(leg: IAvailability) {
    return (
      !leg.walkingDropoff &&
      !!leg.alternative &&
      this.bookingsService.isAlternativeOnFinal(leg, this.newBooking)
    );
  }
}
